<template>
	<div>
		<div class="div_rules" :style="{zIndex:showRules}" :key="Date.now()">
			<div class="rules_view">
				<img class="bg_rules" src="../../assets/bg_rules.png" alt="" />
				<div :class="showRules? 'bg_view' : '' ">
					<div v-html="content"></div>
				</div>
				<img class="close" @click="showRules = -1" src="../../assets/btn_close.png" alt="" />
			</div>
		</div>

		<div class="index_body">
			<!-- <div style="width: 100px;height: 50px;position: absolute;top: 0;right: 0;z-index: 999;" @click="showCo"></div> -->
			<canvas id="canvas" ref="canvas" width="750" height="1625"></canvas>
			<!-- 没有奖品显示的弹窗 -->
			<van-overlay :show="showPop" z-index="999" style="backdrop-filter:blur(4px)">
				<div class="pop_view">
					<img class="bg_pop" src="../../assets/bg_pop.png" alt="" />
					<img class="pop_title" src="../../assets/pop_title.png" alt="" />
					<div class="time_consuming">
						<div class="left">本次耗时：</div>
						<div class="right">
							{{time}}
						</div>
					</div>
					<div class="frequency">
						当日剩余次数：{{ sore }}次
					</div>
					<div class="btn_view">
						<img class="btn" @click="closePop" src="../../assets/btn_back.png" alt="" />
						<img class="btn" v-if="sore != 0" @click="onceAgain" src="../../assets/btn_again.png" alt="" />
					</div>

					<img class="close" @click="closePop" src="../../assets/btn_close.png" alt="" />
				</div>
			</van-overlay>


			<!-- showInfo -->
			<div class="info" v-if="showInfo">
				<img class="info_top" src="../../assets/info_top.png" alt="" />
				<div class="form">
					<!-- <div class="name lable">
						<input type="text" v-model="formData.user_name" placeholder="请输入姓名" :maxlength="10" />
					</div> -->
					<div class="phone lable">
						<input type="number" min="0" max="99999999999"
							oninput="if(this.value.length>11) this.value = this.value.slice(0,11)"
							v-model="formData.user_phone" placeholder="请输入电话号" />
					</div>
					<div class="code lable">
						<input type="number" v-model="formData.verification_code" min="0" max="9999"
							oninput="if(this.value.length>4) this.value = this.value.slice(0,4)" placeholder="请输入验证码" />
						<div v-if="!isTime" class="get_code" @click="getCode">
							获取验证码
						</div>
						<div v-else class="get_code">
							{{ timer }}
						</div>
					</div>
					<!-- <div class="car_model lable" @click="showCarModel = true">
						<div>
							{{ formData.serial_group_name }}
						</div>
					</div> -->

					<!-- <div class="adress lable">
						<div class="province" @click="getProvince">{{formData.province_name}}</div>
						<div class="city" @click="getCity">{{formData.city}}</div>
					</div>

					<div class="car_model lable" @click="getShowDealers">
						<div>
							{{ formData.dealer_name }}
						</div>
					</div> -->

					<div class="title lable">
						<input type="checkbox" v-model="radio_1" name="radio_1" id="radio"><span
							@click="showRules = 999">我已仔细阅读并同意 《用户隐私政策》 及 《活动规则》</span>
					</div>
					<div class="title lable">
						<input type="checkbox" v-model="radio_2" name="radio_2" id="radio">同步注册《红旗空间》小程序会员
					</div>
					<div class="sumbit_view">
						<div class="submit_btn" @click="toDraw">立即抽奖</div>
					</div>
					<div class="logo_w">
						<img src="../../assets/logo_w.png" alt="" />
					</div>
				</div>
			</div>

			<!-- 车型 -->
			<van-popup v-model="showCarModel" position="bottom">
				<van-picker show-toolbar :columns="carModelColumns" value-key="show_name" item-height="56px"
					@confirm="onCarConfirm" @cancel="showCarModel = false">
				</van-picker>
			</van-popup>
			<!-- 省 -->
			<van-popup v-model="showProvince" position="bottom">
				<van-picker show-toolbar :columns="provinceColumns" value-key="name" item-height="56px"
					@confirm="onProvinceConfirm" @cancel="showProvince = false">
				</van-picker>
			</van-popup>
			<!-- 城市 -->
			<van-popup v-model="showCity" position="bottom">
				<van-picker show-toolbar :columns="cityColumns" value-key="name" item-height="56px"
					@confirm="onCityConfirm" @cancel="showCity = false">
				</van-picker>
			</van-popup>
			<!-- 经销商 -->
			<van-popup v-model="showDealers" position="bottom">
				<van-picker show-toolbar :columns="dealersColumns" value-key="dealer_name" item-height="56px"
					@confirm="onDealersConfirm" @cancel="showDealers = false">
				</van-picker>
			</van-popup>

			<!-- 活动规则 -->
			<!-- <van-overlay :show="showRules" z-index="999" style="backdrop-filter:blur(4px)">
				<div class="rules_view">
					<img class="bg_rules" src="../../assets/bg_rules.png" alt="" />
					<div class="bg_view">
						<div v-html="content"></div>
					</div>
					<img class="close" @click="showRules = false" src="../../assets/btn_close.png" alt="" />
				</div>
			</van-overlay> -->
			<!-- 抽奖 -->
			<van-overlay :show="showDraw" z-index="99" style="backdrop-filter:blur(4px)">
				<div class="draw_view">
					<img class="bg_draw" src="../../assets/bg_draw.png" alt="" />
					<img class="bg_drak" ref="luck"
						:style="{transform: 'rotate('+ angle +'deg)',transition: 'transform 4s ease-out'}"
						:class="isLoading?'rotate':''" src="../../assets/bg_drak.png" alt="" />
					<div class="text">{{prize_name}}</div>
					<div class="text_time">本次耗时：<span>{{ time }}</span></div>
					<img class="btn_ok" v-if="showBtn" @click="pirzeOK" src="../../assets/btn_ok.png" alt="" />
					<img class="btn_drak" src="../../assets/btn_drak.png" @click="luckDraw" alt="" />
					<img class="close" @click="closeDraw" src="../../assets/btn_close.png" alt="" />
				</div>
			</van-overlay>
			<Loading v-if="show_loading" />
		</div>

	</div>
</template>

<script>
	import Loading from '../../components/loading/loading.vue';
	import {
		luckDraw
	} from '../../../static/js/common.js'
	import {
		init
	} from '../../../static/js/libs/umcommaan.js'
	import CryptoJS from 'crypto-js';
	// AES 加密/解密工具类（CBC 模式，PKCS7 填充）
	const AesEcbCustomUtil = {
		// 原始密钥（和后端一致）
		RAW_SECRET_KEY: "RX5i|iLkJP,l;x;B",
		// 处理密钥：截取前32位（适配 AES-256），若后端用 AES-128 则改为 slice(0,16)
		getKey: function() {
			// 截取前32位，保证密钥长度符合 AES-256 要求
			const validKey = this.RAW_SECRET_KEY.slice(0, 32);
			return 'RX5i|iLkJP,l;x;B';
		},

		/**
		 * AES/ECB/PKCS5Padding 加密
		 * @param {string} plainText 明文
		 * @returns {string} Hex 格式密文（Java 后端常用）
		 */
		encrypt: function(plainText) {
			if (!plainText) return '';
			const key = CryptoJS.enc.Utf8.parse(this.getKey());
			const encrypted = CryptoJS.AES.encrypt(plainText, key, {
				mode: CryptoJS.mode.ECB,
				padding: CryptoJS.pad.Pkcs7
			});
			return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
		},

		/**
		 * AES/ECB/PKCS5Padding 解密
		 * @param {string} cipherText Hex 格式密文
		 * @returns {string} 明文
		 */
		decrypt: function(cipherText) {
			if (!cipherText) return '';
			const key = this.getKey();
			// 将 Hex 密文转换为 CryptoJS 可识别的格式
			const cipherHex = CryptoJS.enc.Hex.parse(cipherText);
			const cipherParams = CryptoJS.lib.CipherParams.create({
				ciphertext: cipherHex
			});
			// 解密
			const decipher = CryptoJS.AES.decrypt(cipherParams, key, {
				mode: CryptoJS.mode.ECB,
				padding: CryptoJS.pad.Pkcs7
			});
			console.log()
			// 转换为 UTF8 明文
			return CryptoJS.enc.Utf8.stringify(decipher).toString();
		}
	};
	export default {
		components: {
			Loading,
		},
		data() {
			return {
				show_loading: false,
				id: '',
				showDraw: false,
				showPop: false,
				sore: 1,
				time: '20000:00',
				timer: 60,
				isTime: false,
				isInfo: false,
				content: '',
				formData: {
					user_name: '默认',
					user_phone: '',
					verification_code: '',
					serial_group_name: '红旗天工05',
					serial_group_id: '天工05',
					province_name: '吉林省',
					city: '长春市',
					dealer_name: '红旗潜客运营中心',
					dealer_code: 'CDC001',
					channel: '',
				},
				radio_1: true,
				radio_2: true,
				showCarModel: false,
				showProvince: false,
				showCity: false,
				showDealers: false,
				showInfo: false,
				showRules: -1,
				showBtn: false,
				flag: true,
				angle: '',
				complementary: '',
				carModelColumns: [],
				provinceColumns: [],
				cityColumns: [],
				dealersColumns: [],
				winPrizeId: 0,
				prize_name: '点击转盘开始抽奖',
				log_id: '',
				console: 0
			}
		},

		mounted() {
			const that = this
			init()
			// 等待canvas元素准备好
			this.$nextTick(() => {
				if (this.$refs.canvas) {
					this.$refs.canvas.addEventListener('endGame', function(e) {
						// CustomEvent使用detail而不是data
						var gameTime = e.detail ? e.detail.time : (e.data ? e.data.time : null);

						if (!gameTime) {
							console.error('游戏结束事件数据异常:', e);
							jm.showMsg('抱歉，数据异常，请刷新后重新开始游戏');
							return;
						}

						const data = {
							score: +gameTime * 1000,
							game_id: that.id,
							timestamp: Date.now()
						}

						console.log(JSON.stringify(data), '转换成json')
						const aesEn = AesEcbCustomUtil.encrypt(JSON.stringify(data))
						console.log(aesEn, '加密的结果')

						that.time = that.formatSecondsToXXDotXX(gameTime)
						that.$axios.post(jm.site.THIRTY + '/api/v1/hongqi/game/upload-score', aesEn).then(
							res => {
								if (res.code == 200) {
									that.getQy(gameTime)
								} else {
									jm.showMsg(res.msg)
								}
							}).catch((err) => {
							console.error('上传分数失败:', err);
							jm.showMsg(err.message || '上传分数失败，请稍后重试')
						})
					})
				} else {
					console.error('canvas元素未找到，无法绑定endGame事件');
				}
			})
		},
		computed: {
			// 计算属性处理手机号格式化，过滤非数字并限制长度
			formattedPhone: {
				get() {
					return this.formData.user_phone
				},
				set(val) {
					// 1. 过滤所有非数字字符
					const pureNum = val.replace(/\D/g, '')
					// 2. 限制长度不超过11位
					this.formData.user_phone = pureNum.slice(0, 11)
				}
			},
			formattedCode: {
				get() {
					return this.formData.verification_code
				},
				set(val) {
					// 1. 过滤所有非数字字符
					const pureNum = val.replace(/\D/g, '')
					// 2. 限制长度不超过11位
					this.formData.verification_code = pureNum.slice(0, 4)
				}
			}
		},
		created() {
			if (jm.typecode != null && jm.typecode) {
				this.formData.channel = jm.typecode
			} else {
				this.formData.channel = 1
			}
			this.id = window.localStorage.getItem('game_id')
			if (this.$route.query.id) {
				// this.id = this.$route.query.id
				console.log(this.$route.query.code, '经销商code')
			} else {
				this.$router.back(-1)
			}
			const {
				origin,
				pathname,
				hash,
				search
			} = window.location;
			let cleanPath = "";
			if (hash) {
				const cleanHash = hash.split("?")[0];
				cleanPath = origin + pathname + cleanHash;
			} else {
				cleanPath = origin + pathname;
			}
			history.replaceState({}, document.title, cleanPath);
			this.getAddress({
				type: 'province',
			})
			this.getAddress({
				type: 'city',
				province: '吉林省',
				first: true
			})
			this.getDealers({
				province: '吉林省',
				city: '长春市'
			})

			this.getContent()
			this.getModel()
			const that = this

		},
		methods: {
			showCo() {
				this.console++
				if (this.console >= 10) {
					var vConsole = new VConsole();
				}
			},
			getRandomItem(arr) {
				// 边界检查：如果数组为空，直接返回undefined
				if (!Array.isArray(arr) || arr.length === 0) {
					return undefined;
				}
				// 生成0到数组长度-1之间的随机整数
				const randomIndex = Math.floor(Math.random() * arr.length);
				// 返回随机索引对应的数组项
				return arr[randomIndex];
			},
			async pirzeOK() {
				if (this.log_id) {
					const res = await this.$axios.post(jm.site.THIRTY + '/api/v1/hongqi/game/api-goods/receive', {
						log_ids: this.log_id
					})
					if (res.code == 200) {
						jm.showMsg('发放成功')
					}
				}
				this.$router.back(-1)
			},
			async luckDraw() {
				const resInfo = await this.$axios.get(jm.site.THIRTY + '/api/v1/hongqi/game/lead-information')
				if (!resInfo.data) {
					return this.showInfo = true
				}

				let code = ''
				console.log(jm.typecode)
				if (jm.typecode == 1) {
					code = 'SCENE-260127113629139'
				}
				if (jm.typecode == 2) {
					code = 'SCENE-26012711472228'
				}
				if (jm.typecode == 3) {
					code = 'SCENE-26012711473237'
				}
				if (jm.typecode == 4) {
					code = 'SCENE-26012711473874'
				}
				if (jm.typecode == 5) {
					code = 'SCENE-26012711474559'
				}
				if (jm.typecode == 6) {
					code = 'SCENE-26012711475312'
				}

				if (this.flag) {
					this.flag = false
					luckDraw(this, {
						params: {
							code: code
						},
						header: {
							noErrorMsg: false
						},
						retry: {
							open: false,
							count: 3
						}
					}).then(res => {
						// this.winPrizeId = 5; // 0 1.8 | 1 积分 | 2 5.8红包 |  3 积分 |  4 8.8 | 5 积分
						// this.rotateAngle()
						// return
						let name = ''
						if (res.success) {
							if (res.data.prizedto.prize_name == '1.88元红包') {
								this.winPrizeId = 0;
								name = res.data.prizedto.prize_name
							}
							if (res.data.prizedto.prize_name == '3.88元红包') {
								name = res.data.prizedto.prize_name
								this.winPrizeId = 2;
							}
							if (res.data.prizedto.prize_name == '6.88元红包') {
								name = res.data.prizedto.prize_name
								this.winPrizeId = 4;
							}
							if (res.data.prizedto.prize_name.includes('积分')) {
								name = res.data.prizedto.prize_name
								this.log_id = res.data.prizedto.goods[0].log_id
								this.winPrizeId = 1;
							}
							if (res.data.prizedto.prize_name.includes('不中奖')) {
								name = '谢谢惠顾'
								this.winPrizeId = 5;
							}
							this.rotateAngle(name)
						} else {
							this.flag = true
							let msg = res.msg.trim()
							switch (msg) {
								case '串码还未激活':
									this.errorType = 2
									// 查询码信息
									this.getCodeInfo(res => {
										this.errMsg = {
											code: res.code_id,
										}
										this.isShowError = true // 是否展示错误弹窗
									})
									break;

								case '当前串码已经被核销':
									this.errorType = 3
									// 查询码信息
									this.getCodeInfo(res => {
										this.errMsg = {
											code: res.code_id,
											code_time: res.scan_time,
										}
										this.isShowError = true // 是否展示错误弹窗
									})
									break;

								case '今日活动抽奖次数已经达到最大':
									this.errorType = 4
									this.isShowError = true // 是否展示错误弹窗
									this.codeValue = ''
									break;

								case '您本次活动抽奖次数已经达到最高':
									this.errorType = 5
									this.isShowError = true // 是否展示错误弹窗
									this.codeValue = ''
									break;

								case '串码已经废弃':
									this.errorType = 5
									this.isShowError = true // 是否展示错误弹窗
									this.codeValue = ''
									break;

								case '活动还未开始':
									this.codeValue = ''
									break;

								case '活动已经结束':
									this.errorType = 6
									this.isShowError = true // 是否展示错误弹窗
									this.codeValue = ''
									break;

								default:
									this.codeValue = ''
									jm.showMsg(msg)
									break;
							}
						}
					}).catch(() => {
						this.flag = true
						this.codeValue = ''
					})
				}
			},
			rotateAngle(name) { //计算旋转角度
				console.log('奖品名称', name)
				const that = this
				let times = 0.001722
				if (this.angle % 360 != 0) {
					this.complementary = 360 - (this.angle % 360)
				} else {
					this.complementary = 0
				}
				this.angle = Number(this.angle) + (720 + 30 + (this.winPrizeId * 60)) + (this.complementary);
				this.$refs.luck.style.transition = `transform ${720*times}s ease-out`

				this.rotate_timer = setTimeout(() => {
					// this.flag = true
					that.prize_name = name
					that.showBtn = true
					clearTimeout(that.rotate_timer)
				}, 729 * times * 1000 + 800)

			},
			closeDraw() {
				this.showDraw = false
				this.$router.back(-1)

			},
			getContent() {
				this.$axios.get(jm.site.ACTJEXTRA + '/api/v1/act/copywritingcontent', {
					params: {
						act_code: localStorage.getItem('act')
					},
				}).then(res => {
					console.log(res)
					if (res.success && res.data) {
						this.content = res.data.copywriting_content
					}
				})
			},
			toDraw() {
				const that = this
				if (!this.formData.user_name.trim()) {
					return jm.showMsg('请输入姓名')
				}
				if (!this.formData.user_phone.trim()) {
					return jm.showMsg('请输入手机号')
				}
				if (this.formData.user_phone.length != 11) {
					return jm.showMsg('请输入正确的手机号')
				}
				if (!this.formData.verification_code.trim()) {
					return jm.showMsg('请输入验证码')
				}
				if (this.formData.verification_code.length != 4) {
					return jm.showMsg('请输入正确的验证码')
				}
				if (this.formData.serial_group_name == '请选择车型') {
					return jm.showMsg('请输入车型')
				}
				if (this.formData.province_name == '请选择省份') {
					return jm.showMsg('请选择省份')
				}
				if (this.formData.city == '请选择城市') {
					return jm.showMsg('请选择城市')
				}
				if (this.formData.dealer_name == '请选择经销商') {
					return jm.showMsg('请选择经销商')
				}
				if (!this.radio_1) {
					return jm.showMsg('您需要勾选同意协议才能继续操作')
				}
				if (!this.radio_2) {
					return jm.showMsg('需同步注册小程序会员才能完成当前操作')
				}
				this.$axios.post(jm.site.THIRTY + '/api/v1/hongqi/game/lead-information', this.formData).then(res => {
					if (res.code == 200) {
						that.showInfo = false
						jm.showMsg('提交成功')
						setTimeout(() => {
							that.luckDraw()
						}, 500)
						// that.showDraw = true

					} else {
						jm.showMsg(res.msg)
					}
				})
			},
			getShowDealers() {
				if (this.formData.province_name == '请选择省份') {
					return jm.showMsg('请选择省份')
				}
				if (this.formData.city == '请选择城市') {
					return jm.showMsg('请选择城市')
				}
				this.getDealers({
					province: this.formData.province_name,
					city: this.formData.city
				})
				this.showDealers = true
			},
			onDealersConfirm(e, idx) {
				this.formData.dealer_name = e.dealer_name
				this.formData.dealer_code = e.dealer_id
				this.showDealers = false
			},
			getDealers(data) {
				const that = this
				this.$axios.post(jm.site.THIRTY + '/api/v1/hongqi/game/dealers', data).then(res => {
					console.log('经销商', res)
					that.dealersColumns = res.data
				})
			},
			getProvince() {
				this.showProvince = true
			},
			getCity() {
				if (this.formData.province_name == '请选择省份') {
					return jm.showMsg('请选择省份')
				}
				this.showCity = true
			},
			onCityConfirm(e, idx) {
				this.formData.city = e.name
				this.showCity = false
			},
			onProvinceConfirm(e, idx) {
				console.log(e)
				this.formData.province_name = e.name
				this.formData.city = '请选择城市'
				this.getAddress({
					type: 'city',
					province: e.name
				})
			},
			getAddress(data) {
				console.log(data)
				const that = this
				this.$axios.post(jm.site.THIRTY + '/api/v1/hongqi/game/region/list', data).then(res => {
					if (data.type == 'province') {
						that.provinceColumns = res.data
					} else {
						if (data.first == true) {
							that.cityColumns = res.data
						} else {
							that.cityColumns = res.data
							that.formData.dealer_name = '请选择经销商'
							that.formData.dealer_id = ''
						}

					}
					that.showProvince = false
					that.showCity = false
				})

			},
			getModel() {
				const that = this
				this.$axios.post(jm.site.THIRTY + '/api/v1/hongqi/game/car-serial-groups').then(res => {
					console.log('获取车型', res)
					that.carModelColumns = res.data
					const obj = that.getRandomItem(that.carModelColumns)
					that.formData.serial_group_name = obj.show_name
					that.formData.serial_group_id = obj.id
				})
			},
			onCarConfirm(e, idx) {
				this.formData.serial_group_name = e.show_name
				this.formData.serial_group_id = e.id
				this.showCarModel = false
				console.log(e, idx)
			},
			getCode() {
				const that = this
				const headers = {
					"content-type": "application/x-www-form-urlencoded"
				}
				console.log(that.formData.user_phone.trim())
				if (!that.formData.user_phone.trim()) {
					return jm.showMsg('请输入手机号')
				}
				if (that.formData.user_phone.trim().length != 11) {
					return jm.showMsg('请输入正确的手机号')
				}
				this.$axios.post(jm.site.AUTHSITE + '/api/v1/smsservice', that.$qs.stringify({
					phone_number: that.formData.user_phone,
					template_id: '1769998729745',
					remark: '红旗留资获取手机号',
				}), {
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				}).then(res => {
					if (res.code == 200) {
						that.isTime = true
						const times = setInterval(() => {

							if (that.timer > 0) {
								that.timer--
							} else {
								this.isTime = false
								that.timer = 60
								clearInterval(times)
							}
						}, 1000)
					} else {
						jm.showMsg(res.msg)
					}
				}).catch((err) => {
					jm.showMsg('获取验证码失败，请稍后重新')
				})

			},
			onceAgain() {
				this.toGames()
			},
			formatSecondsToXXDotXX(seconds) {
				// 步骤 1：容错处理，将入参转为合法数字（非数字默认返回 0.00）
				const num = Number(seconds);
				if (isNaN(num)) {
					console.warn("传入的秒数无效，已默认转为 0.00");
					return "0.00";
				}

				// 步骤 2：保留 2 位小数（四舍五入），并自动补 0
				// toFixed(2) 会自动将数字格式化为 2 位小数，不足补 0，返回字符串
				return num.toFixed(2);
			},
			closePop() {
				this.$router.back(-1)
			},
			// 是否留资
			getInfo() {
				const that = this
				this.$axios.get(jm.site.THIRTY + '/api/v1/hongqi/game/lead-information').then(res => {
					console.log('是否留资', res)
					if (!res.data) {
						that.isInfo = false
						// that.showInfo = true
					} else {
						that.isInfo = true
						// that.showDraw = true
					}
				})
			},
			// 获取是否有抽奖几回
			getQy(time) {
				const that = this
				this.$axios.get(jm.site.usercenterSite + '/api/v1/user/seniority', {
					member_id: 'SEN26012314134721',
					user_id: jm.user_id
				}).then(res => {
					// console.log(res.data[0].total_count - res.data[0].used_count, '是否有抽奖次数')
					if (res.success && res.data && res.data.length > 0 && (res.data[0].total_count - res.data[0].used_count) > 0) {
						that.showDraw = true
					} else {
						that.getSore(time)
					}
				}).catch(err => {
					that.getSore(time)
					jm.showMsg(err)
				})
			},
			// 获取活动次数
			getSore(time) {
				const that = this
				this.$axios.post(jm.site.THIRTY + '/api/v1/hongqi/game/today-participation-count').then(res => {
					that.sore = res.data
					that.time = that.formatSecondsToXXDotXX(time)
					that.showPop = true
				}).catch((err) => {
					jm.showMsg('获取活动次数数据异常，请刷新页面重试' + err)
					that.$router.back(-1)
				})
			},
			toGames() {
				const that = this
				this.$axios.post(jm.site.THIRTY + '/api/v1/hongqi/game/today-participation-count').then(res => {
					that.sore = res.data
					if (res.data > 0) {
						that.$axios.post(jm.site.THIRTY + '/api/v1/hongqi/game/participation').then(res2 => {
							if (res2.code == 200) {
								that.id = res2.data
								that.showPop = false
								init()
							} else {
								jm.showMsg(res2.msg)
							}
						})
					} else {
						jm.showMsg('今天的活动次数用完啦，明天再试试吧')
						console.log('无抽奖次数')
					}
				})

			},
		},
	}
</script>

<style lang="scss" scoped>
	.close {
		position: absolute;
		top: 1.15rem;
		right: .8rem;
		transform: translate(-50%, 0);
		width: .8rem;
		height: .8rem;
	}

	.div_rules {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, .7);
		backdrop-filter: blur(4px)
	}

	.rules_view {
		width: 17.35rem;
		height: 22.9rem;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);

		.bg_rules {
			width: 17.35rem;
			height: 22.9rem;

		}

		.bg_view {
			width: 14.75rem;
			height: 18.8rem;
			position: absolute;
			top: 3.1rem;
			left: 50%;
			margin-left: -7.375rem;
			border-radius: .8rem;
			background: #ffffff;
			overflow: hidden;
			overflow-y: auto;
			padding: .4rem;
		}

		.close {
			position: absolute;
			top: 1.15rem;
			right: .8rem;
			transform: translate(-50%, 0);
			width: .8rem;
			height: .8rem;
		}
	}

	.draw_view {
		width: 17.375rem;
		height: 27.75rem;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);

		.bg_draw {
			width: 100%;
			height: 100%;
		}

		.bg_drak {
			width: 15.15rem;
			height: 15.15rem;
			position: absolute;
			top: 5.55rem;
			left: 50%;
			margin-left: -7.575rem;
		}

		.text_time {
			position: absolute;
			top: 3.1rem;
			width: 100%;
			text-align: center;
			color: #BA0A04;

			font-weight: bold;
			font-size: 1rem;

			span {
				color: #FFB919;
				background: #BA0A04;
				padding: 0 10px;
				border-radius: 0.35rem;
			}
		}

		.text {
			position: absolute;
			bottom: 5rem;
			width: 100%;
			text-align: center;
			color: #BA0A04;
			font-weight: bold;
			font-size: 1rem;
		}

		.btn_ok {
			width: 12.8rem;
			position: absolute;
			bottom: 1rem;
			left: 50%;
			margin-left: -6.4rem;
		}

		.btn_drak {
			width: 6.175rem;
			height: 6.175rem;
			position: absolute;
			top: 10.35rem;
			left: 50%;
			margin-left: -3.0875rem;
		}
	}

	.index_body {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		overflow: hidden;
		background: linear-gradient(360deg, #191B3F 0%, #412A64 100%);

		#canvas {
			position: absolute;
			top: 0;
			// height: 100vh !important;
			// object-fit: cover;
		}

		.pop_view {
			width: 17.375rem;
			height: 13.3rem;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);

			.bg_pop {
				width: 17.375rem;
				height: 9.6rem;
			}

			.time_consuming {
				position: absolute;
				top: 4.05rem;
				width: 100%;
				font-size: 0.9rem;
				line-height: 1.65rem;
				font-weight: bold;
				// text-align: center;
				display: flex;
				justify-content: center;
				align-items: center;

				.left {
					color: #BA0A04;
				}

				.right {
					color: #FFB919;
					background: #BA0A04;
					padding: 0 10px;
					border-radius: 0.35rem;
				}
			}

			.frequency {
				position: absolute;
				width: 100%;
				font-size: 0.9rem;
				top: 6.75rem;
				font-weight: bold;
				color: #BA0A04;
				text-align: center;
			}

			.pop_title {
				position: absolute;
				top: .25rem;
				left: 50%;
				width: 8.8rem;
				height: 1.575rem;
				margin-left: -4.4rem;
			}

			.btn_view {
				height: 2.9rem;
				width: 100%;
				position: absolute;
				bottom: 0;
				display: flex;
				justify-content: space-around;

				.btn {
					width: 7.8rem;
					height: 2.9rem;
				}
			}
		}

		.info {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: #950002;
			overflow: hidden;
			overflow-y: auto;
			z-index: 100;

			.info_top {
				width: 100%;
				height: 9.9rem;
			}

			.form {
				width: 16.625rem;
				margin: 0 auto;
				color: #666666;

				.lable {
					color: #999999;
					margin-bottom: 1rem;

					input {
						width: 100%;
						height: 1.85rem;
						background: #fff;
						border-radius: 1rem;
						padding-left: 3.55rem;
						position: relative;
						font-size: 0.6rem;

						::-webkit-input-placeholder {
							color: #666666;
							font-weight: bold;
						}

						::-moz-placeholder {
							color: #666666;
							font-weight: bold;
						}

						::placeholder {
							color: #666666;
							font-weight: bold;
						}
					}
				}



				.name {
					position: relative;

					&:before {
						content: '姓名';
						position: absolute;
						top: 0;
						left: 1rem;
						height: 1.85rem;
						line-height: 1.85rem;
						z-index: 99;
					}

				}

				.phone {
					position: relative;

					&:before {
						content: '电话';
						position: absolute;
						top: 0;
						left: 1rem;
						height: 1.85rem;
						line-height: 1.85rem;
						z-index: 99;
					}

				}

				.code {
					position: relative;

					&:before {
						content: '验证码';
						position: absolute;
						top: 0;
						left: 1rem;
						height: 1.85rem;
						line-height: 1.85rem;
						z-index: 99;
					}

					&:after {
						content: '';
						position: absolute;
						top: 50%;
						right: 4.65rem;
						width: 1px;
						height: 1.05rem;
						background: #999999;
						transform: translate(0, -50%);
					}

					.get_code {
						position: absolute;
						top: 0;
						right: 0;
						height: 1.85rem;
						width: 4.6rem;
						box-sizing: border-box;
						line-height: 1.85rem;
						text-align: center;
						color: #999999;
					}
				}

				.car_model {
					height: 1.85rem;
					background: #fff;
					line-height: 1.85rem;
					padding-left: 1rem;
					border-radius: 1rem;
					color: #666666;
					position: relative;

					&:after {
						content: '';
						/* 必须保留空content，伪元素才能渲染，图片通过背景引入 */
						width: 0.4rem;
						/* 你想要的图片宽度 */
						height: 0.65rem;
						/* 你想要的图片高度 */
						position: absolute;
						top: 0;
						right: 1rem;
						margin: .6rem 0;
						/* 你的原有定位间距 */
						background-image: url('../../assets/icon_go.png');
						/* 引入图片 */
						background-size: 100% 100%;
						/* 关键：让图片填满伪元素容器，实现尺寸控制 */
						background-repeat: no-repeat;
						/* 防止图片重复（可选，单张图片建议添加） */
						background-position: center;
						/* 图片在容器内居中（可选，优化对齐） */
					}
				}

				.sumbit_view {
					height: 2.3rem;
					margin-top: 1.2rem;
					background: #EEC197;
					border-radius: 1.2rem;
					color: #900000;
					line-height: 2.3rem;
					text-align: center;
					font-weight: bold;
					margin-bottom: 1.65rem;
				}

				.logo_w {
					width: 8.6rem;
					// width: 100%;
					margin: 0 auto;
					margin-bottom: .25rem;

					img {
						width: 8.6rem;
						height: .6rem;
					}
				}

				.title {
					font-size: .55rem;
					margin-bottom: .4rem;
					display: flex;
					align-items: center;
					color: #999999;
					white-space: nowrap;

					#radio {
						width: .6rem;
						height: .6rem;
						border-radius: .1rem;
						margin-right: .4rem;

						display: inline-flex;
						align-items: center;
						margin-right: 1rem;
						cursor: pointer;
						position: relative;
						padding-left: 0.9rem;
						/* 给 24rpx 的单选框留足够空间（24rpx + 12rpx 间距） */
					}

					/* 1. 隐藏原生 radio，保留功能 */
					#radio input {
						display: none;
					}

					/* 2. label 样式：点击区域，对齐文字 */
					#radio label {
						display: inline-flex;
						align-items: center;
						margin-right: 1rem;
						cursor: pointer;
						position: relative;
						padding-left: 0.9rem;
						/* 给 24rpx 的单选框留足够空间（24rpx + 12rpx 间距） */
					}

					/* 3. 模拟单选框样式（完全对应你给出的参数）- 未选中状态 */
					#radio label::before {
						content: '';
						position: absolute;
						left: 0;
						top: 50%;
						transform: translateY(-50%);
						width: 0.6rem;
						/* 你的要求：宽度 24rpx */
						height: 0.6rem;
						/* 你的要求：高度 24rpx */
						background: #CCCCCC;
						/* 你的要求：背景色 #CCCCCC */
						border-radius: 0.1rem;
						/* 你的要求：圆角 4rpx（简写等价于 4rpx 4rpx 4rpx 4rpx） */
						border: none;
						/* 背景色已设置，无需额外边框，如需边框可添加 */
					}

					/* 4. 选中状态样式（可选，添加内部填充，区分选中/未选中，提升体验） */
					#radio label::after {
						content: '';
						position: absolute;
						left: 0.1rem;
						/* 居中对齐：(24rpx - 16rpx)/2 = 4rpx */
						top: 50%;
						transform: translateY(-50%);
						width: 0.4rem;
						/* 内部填充尺寸，小于外部容器 */
						height: 0.4rem;
						background: #666;
						/* 选中后内部填充色，可自定义（如品牌色） */
						border-radius: 0.05rem;
						/* 内部圆角，略小于外部，保持协调 */
						display: none;
						/* 未选中时隐藏 */
					}

					/* 5. 选中状态：显示内部填充 */
					#radio input:checked+label::before {
						/* 可选：选中后修改外部背景色，增强区分 */
						background: #e5e5e5;
					}
				}

				.adress {
					height: 1.85rem;
					line-height: 1.85rem;
					color: #666666;
					display: flex;
					justify-content: space-between;

					.province {
						width: 7.925rem;
						height: 1.85rem;
						background: #fff;
						border-radius: 1rem;
						padding: 0 1rem;
						box-sizing: border-box;
						position: relative;

						&:after {
							content: '';
							/* 必须保留空content，伪元素才能渲染，图片通过背景引入 */
							width: 0.4rem;
							/* 你想要的图片宽度 */
							height: 0.65rem;
							/* 你想要的图片高度 */
							position: absolute;
							top: 0;
							right: 1rem;
							margin: .6rem 0;
							/* 你的原有定位间距 */
							background-image: url('../../assets/icon_go.png');
							/* 引入图片 */
							background-size: 100% 100%;
							/* 关键：让图片填满伪元素容器，实现尺寸控制 */
							background-repeat: no-repeat;
							/* 防止图片重复（可选，单张图片建议添加） */
							background-position: center;
							/* 图片在容器内居中（可选，优化对齐） */
						}
					}

					.city {
						width: 7.925rem;
						height: 1.85rem;
						background: #fff;
						border-radius: 1rem;
						padding: 0 1rem;
						box-sizing: border-box;
						position: relative;

						&:after {
							content: '';
							/* 必须保留空content，伪元素才能渲染，图片通过背景引入 */
							width: 0.4rem;
							/* 你想要的图片宽度 */
							height: 0.65rem;
							/* 你想要的图片高度 */
							position: absolute;
							top: 0;
							right: 1rem;
							margin: .6rem 0;
							/* 你的原有定位间距 */
							background-image: url('../../assets/icon_go.png');
							/* 引入图片 */
							background-size: 100% 100%;
							/* 关键：让图片填满伪元素容器，实现尺寸控制 */
							background-repeat: no-repeat;
							/* 防止图片重复（可选，单张图片建议添加） */
							background-position: center;
							/* 图片在容器内居中（可选，优化对齐） */
						}
					}


				}


			}


		}

	}
</style>


// WEBPACK FOOTER //
// src/pages/games/index.vue